import transitionPage from "@/components/transitionPage/index";

export default {
  name: "login",
  metaInfo() {
    return {
      title: this.$t("seo.login.title"),
      meta: [{ name: "description", content: this.$t("seo.login.description") }]
    };
  },
  components: { transitionPage },
  props: [],
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
